/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Week_StartInputs */



/**
* | output |
* | --- |
* | "Start of the week" |
*
* @param {Settings_Week_StartInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_week_start = /** @type {((inputs?: Settings_Week_StartInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Week_StartInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Start van de week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Début de la semaine")
	return /** @type {LocalizedString} */ ("Start of the week")
});